import React from 'react';
import ContourImages from '../../gral-components/ContourImages';
import EditProfilePhoto from './EditProfilePhoto';
import EditPersonalInfo from './EditPersonalInfo';
import ProfileList from './ProfileList';
import {
  IconUserTie,
  IconAccountClock,
  IconBxWorld,
  IconUserGraduate,
  IconClockHistory,
  IconLocation,
  IconUserSkillsLine,
  IconCheckCircle,
  IconTools,
  IconVideo
} from '../../icons/icons';
import '../stylesheets/profile.scss';



class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      click: 'studies',
      render: 'studies',
      photoEdit: false,
      personalInfoEdit: false
    };
  };

  photoEditHandle = () => {
    this.setState({
      photoEdit: !this.state.photoEdit
    });
  };
  personalInfoEditHandle = () => {
    this.setState({
      personalInfoEdit: !this.state.personalInfoEdit
    });
  };
  updateStateHandle = () => {
    if (!this.state.updateState) {
      this.setState({
        updateState: true
      });
    }
  };
  handleClick = (e) => {
    let clicked = e.currentTarget.dataset.value;
    this.setState({
      render: clicked,
      click: clicked
    });
  };

  render() {
    let userCurrent = this.props.dataUser;
    let render = this.state.render;
    let experience = userCurrent[0].experience;
    let idioms = userCurrent[0].idioms;
    let certification = userCurrent[0].certification;
    let endorsement = userCurrent[0].endorsement;
    let skill = userCurrent[0].skill;
    let coverVideo = userCurrent[0].coverVideo;

    const listItems = [
      { item: 'Studies', dataValue: 'studies', icon: <IconUserGraduate />, key: experience },
      { item: 'Certifications', dataValue: 'certification', icon: <IconUserSkillsLine />, key: certification },
      { item: 'Experience years ', dataValue: 'experience', icon: <IconAccountClock />, key: experience },
      { item: 'Endorsements', dataValue: 'endorsement', icon: <IconCheckCircle />, key: endorsement },
      { item: 'Skills', dataValue: 'skill', icon: <IconTools />, key: skill },
      { item: 'Spoken idiom', dataValue: 'idiom', icon: <IconBxWorld />, key: idioms },
      { item: 'Cover video', dataValue: 'cover-video', icon: <IconVideo />, key: coverVideo }
    ];

    let renderSwitch =
      render === 'studies'
        ? 'studies'
        : render === 'experience'
          ? 'experiences'
          : render === 'idiom'
            ? 'idioms'
            : render === 'certification'
              ? 'certifications'
              : render === 'endorsement'
                ? 'endorsement'
                : render === 'skill'
                  ? 'Skills'
                  : render === 'cover-video'
                    ? 'Cover Video'
                    : '';

    return (
      <div className='profile-container'>
        <div className='profile-overview'>
          <div className='image-container'>
            <button
              type='button'
              className='profile-photo'
              onClick={this.photoEditHandle}
            >
              <ContourImages
                image={this.props.userImage}
              />
            </button>
          </div>
          <div className='profile-personal-information'>
            <div className='profile-name-container'>
              <div className='profile-name'>
                <h2>
                  {`${this.props.personalInfo.firstname} ${this.props.personalInfo.lastname}`}
                </h2>
                <h4>
                  {this.props.email}
                </h4>
              </div>
            </div>
            <ul className='profile-brief-item'>
              <li key='talent' className='profile-talent'>
                <i><IconUserTie /></i>
                <h4>{this.props.personalInfo.talent}</h4>
              </li>
              <li key='location' className='profile-location'>
                <i><IconLocation /></i>
                <h4>{this.props.personalInfo.location}</h4>
              </li>
              <li key='availability' className='profile-availability'>
                <i><IconClockHistory /></i>
                <h4>{`${this.props.personalInfo.availability} (${this.props.personalInfo.workTime})`}</h4>
              </li>
            </ul>
            <div className='profile-summary'>
              <h4><strong>Personal description</strong></h4>
              <h5>{this.props.personalInfo.description}</h5>
            </div>
            <button
              type='button'
              className='edit-personal-information'
              onClick={this.personalInfoEditHandle}
            >
              <h4>Edit</h4>
            </button>
          </div>
        </div>
        <div className='profile-description-container'>
          <div className='profile-description-list'>
            <ul className='profile-list-ul'>
              {
                listItems.map((item, index) =>
                  <ProfileList
                    data={item}
                    key={index}
                    onClick={this.handleClick}
                    clicked={this.state.click}
                  />

                )
              }
            </ul>
          </div>
          <div className='profile-description'>
            {renderSwitch}
          </div>
        </div>
        <EditProfilePhoto
          userImage={this.props.userImage}
          photoEditState={this.state.photoEdit}
          photoEditClose={this.photoEditHandle}
          updateHandle={this.props.updateHandle}
        />
        <EditPersonalInfo
          personalInfoState={this.state.personalInfoEdit}
          personalInfoEditClose={this.personalInfoEditHandle}
          updateHandle={this.props.updateHandle}
        />
      </div>
    );
  }
};

export default Profile;